<template>
  <div class="campaign-child">
    <questionnaire v-if="questionnaire && questionnaire.length > 0" :id="questionnaire[0]"></questionnaire>
  </div>
</template>

<script>
import Questionnaire from '@/components/Voting/Questionnaire.vue'

export default {
  name: 'CampaignVoting',

  components: {
    'questionnaire': Questionnaire
  },

  computed: {
    campaign () {
      return this.$route.name === 'campaign-info'
        ? this.$store.getters.campaign
        : this.$store.getters.ncCampaign
    },

    questionnaire () {
      return this.$store.state.campaigns.campaign.questionnaire
    }
  }
}
</script>
